export default __webpack_public_path__ + "static/media/time.cfd35776.svg";